import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Button, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { OnboardingLayout } from './components/OnboardingLayout/OnboardingLayout';
import { useOnboardingFlow } from './hooks/useOnboardingFlow';
import styles from './VendorOnboarding.module.scss';
export const GetVendorOnboardingTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const VendorOnboarding = (param)=>{
    let { testId, onComplete } = param;
    const testIds = useMemo(()=>GetVendorOnboardingTID(testId), [
        testId
    ]);
    const skipInviteTeam = false;
    const { currentStep, progress, isSkippableStep, goNext, goBack } = useOnboardingFlow({
        skipInviteTeam
    });
    const handleContinue = ()=>{
        if (currentStep === 'closing') {
            onComplete();
            return;
        }
        goNext();
    };
    const isIntroOrCredits = currentStep === 'intro' || currentStep === 'credits';
    const isWaitingOrClosing = currentStep === 'waiting' || currentStep === 'closing';
    if (isIntroOrCredits || isWaitingOrClosing) {
        return /*#__PURE__*/ _jsxs(Box, {
            className: styles.root,
            testId: testIds.VendorOnboardingTestIds.Root(),
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: testIds.VendorOnboardingTestIds.StepContent(),
                    children: currentStep
                }),
                /*#__PURE__*/ _jsx(Button, {
                    skin: "primary",
                    onClick: handleContinue,
                    testId: testIds.VendorOnboardingTestIds.NextButton(),
                    children: "Next"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.root,
        testId: testIds.VendorOnboardingTestIds.Root(),
        children: /*#__PURE__*/ _jsx(OnboardingLayout, {
            progress: progress,
            onBack: goBack,
            onContinue: handleContinue,
            showSkipButton: isSkippableStep,
            onSkip: goNext,
            children: /*#__PURE__*/ _jsx(Typography, {
                testId: testIds.VendorOnboardingTestIds.StepContent(),
                children: currentStep
            })
        })
    });
};
